import React from "react";
import ContentBlock from "../../Element_Components/contentBlock/ContentBlock";
import { useTranslate } from "@/utils/languageTranslation";
type OverViewProps = {
  name: string;
  governorImage: string;
  governorImageWidth?: number;
  governorImageHeight?: number;
  governorName: string;
  governerPosition: string;
  focusArea:[
    {
      title: string;
      description: string;
    }
  ];
  message: string;
  overview: string;
};

const OverViewBlock: React.FC<OverViewProps> = ({
  name,
  governorImage,
  governorName,
  governerPosition,
  focusArea,
  message,
  overview,
}) => {
  const {t} = useTranslate()
  return (
    <div className="w-full ">
      <div className="max-w-[71rem] mx-auto py-8 grid md:grid-cols-3 gap-6 md:mt-14 md:px-5 xl:px-0 min-h-[43.5rem]">
        {/* Governor Profile */}
        <div>
        <ContentBlock  imageUrl={governorImage}  textPrimary={governorName} textSecondary={governerPosition} 
        thirdText={message} layout='top' link="/about/president-message" linkText={t('read_more')} />
        </div>
        
        {/* Main Content */}
        <div className="md:col-span-2 flex flex-col space-y-8">
          <div className="md:justify-items-start justify-items-center md:p-0 px-4">
            <h2 className="text-2xl md:text-4xl font-bold text-[#002B4E] md:text-start text-center">{name}</h2>
          </div>
          <div className="flex flex-1 lg:p-0 px-5">
            <p className="text-[#4A4A4A] text-base md:text-lg">{overview}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-10 min-h-[25.25rem] place-items-center md:place-items-start px-5 md:px-0">
            {
              focusArea.map((focus,index)=>{
                   return(
                    <div className="bg-[#F4F8FB] py-[1rem] px-3 lg:p-[1.25rem] space-y-2 lg:space-y-4 rounded-lg w-full xl:min-w-[22.7rem] sm:max-w-[22.7rem] min-h-[11.8rem] md:min-h-[11.8rem] md:h-full " key={index}>
                      <h3 className="text-lg xl:text-2xl font-bold text-[#002B4E] text-center md:text-start">{focus.title}</h3>
                      <p className="text-[#4A4A4A] text-base xl:text-lg text-center md:text-start">{focus.description}</p>
                    </div>
                   )
              })
            }  
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverViewBlock;